/**
 * Centralized API Configuration
 * 
 * This configuration is used by both Family and Device frontends.
 * Works for:
 * - Render deployment (app.hayatfamily.app)
 * - Cloudflare Pages deployment (device.hayatfamily.app)
 * - Local development (localhost:3000)
 */

// API Base URL - Always points to Render backend
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL 
  || process.env.REACT_APP_API_BASE_URL 
  || 'https://api.hayatfamily.app';

// WebSocket URL - For real-time features (calls, notifications)
export const WS_BASE_URL = process.env.REACT_APP_WEBSOCKET_URL 
  || API_BASE_URL.replace('https://', 'wss://').replace('http://', 'ws://');

// Helper to build full API URL
export const buildApiUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
};

// Helper to build WebSocket URL
export const buildWsUrl = (path) => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${WS_BASE_URL}/${cleanPath}`;
};

// Development mode detection
export const isDevelopment = process.env.NODE_ENV === 'development';

// Domain detection
export const getCurrentDomain = () => {
  if (typeof window === 'undefined') return '';
  return window.location.hostname;
};

// Check if running on device domain
export const isDeviceDomain = () => {
  const hostname = getCurrentDomain();
  return hostname === 'device.hayatfamily.app' 
    || hostname.includes('hayat-family.pages.dev')
    || hostname.includes('.pages.dev');
};

// Check if running on family domain
export const isFamilyDomain = () => {
  const hostname = getCurrentDomain();
  return hostname === 'app.hayatfamily.app'
    || hostname.includes('.onrender.com')
    || hostname === 'localhost';
};

// Log configuration in development
if (isDevelopment) {
  console.log('[API Config] API_BASE_URL:', API_BASE_URL);
  console.log('[API Config] WS_BASE_URL:', WS_BASE_URL);
  console.log('[API Config] Current Domain:', getCurrentDomain());
  console.log('[API Config] Is Device Domain:', isDeviceDomain());
  console.log('[API Config] Is Family Domain:', isFamilyDomain());
}

export default {
  API_BASE_URL,
  WS_BASE_URL,
  buildApiUrl,
  buildWsUrl,
  isDevelopment,
  getCurrentDomain,
  isDeviceDomain,
  isFamilyDomain,
};
